<template>

    <div class="menu1">

        <el-row class="menu2">
            <el-col class="menu3">
                <el-menu class="elmenu" :default-active="activeIndex" :router="rou" background-color="#545c64"
                    text-color="#fff" active-text-color="#ffd04b">


                    <el-menu-item index="/index/user">
                        <i class="el-icon-menu"></i>
                        <span slot="title">用户管理</span>
                    </el-menu-item>

                    <el-menu-item index="/index/group">
                        <i class="el-icon-menu"></i>
                        <span slot="title">群组管理</span>
                    </el-menu-item>

                    <el-menu-item index="/index/package">
                        <i class="el-icon-document"></i>
                        <span slot="title">APK包管理</span>
                    </el-menu-item>

                    <el-menu-item index="/index/wgt">
                        <i class="el-icon-document"></i>
                        <span slot="title">WGT包管理</span>
                    </el-menu-item>

                    <el-menu-item index="/index/action">
                        <i class="el-icon-bangzhu"></i>
                        <span slot="title">动作库</span>
                    </el-menu-item>

                    <el-menu-item index="/index/course">
                        <i class="el-icon-s-data"></i>
                        <span slot="title">课程库</span>
                    </el-menu-item>

                    <el-menu-item index="/index/scene">
                        <i class="el-icon-s-data"></i>
                        <span slot="title">场景库</span>
                    </el-menu-item>

                  <el-menu-item index="/index/cover">
                    <i class="el-icon-s-data"></i>
                    <span slot="title">封面库</span>
                  </el-menu-item>

                  <el-menu-item index="/index/specification">
                    <i class="el-icon-s-data"></i>
                    <span slot="title">规格说明书</span>
                  </el-menu-item>
                   

                </el-menu>
            </el-col>
        </el-row>





    </div>
</template>

<script>


export default {

    data() {
        return {
            rou: true,
            activeIndex: this.$route.path
        };
    },

    methods: {

    }
}




</script>


<style>
ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

}

li {
    width: 100%;
    height: 100%;
    display: flex;

    justify-content: flex-start;
    align-items: center;
}



.menu1 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;


}

.menu2 {
    width: 100%;
    height: 100%;
}

.menu3 {
    width: 100%;
    height: 100%;



}

.menu4 {
    width: 100%;
    height: 100%;
}
</style>
